import moment from 'moment';
import { useGet } from 'state/jotai';
import { current_language } from 'state/store.global'
import 'moment/dist/locale/da';
import 'moment/dist/locale/sv';


const Months = [
  'Januar',
  'Februar',
  'Marts',
  'April',
  'Maj',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'December',
]

const Days = [
  'Søndag',
  'Mandag',
  'Tirsdag',
  'Onsdag',
  'Torsdag',
  'Fredag'
]

export const WDay = (x) => {
  const date = new Date(x)
  
  // return Days[date.getDay()]
  return moment(date).format('dddd')
}

export const MDay = (x) => {
  const date = new Date(x)
  return date.getDate()
}

export const Month = (x,language) => {
  const date = new Date(x)

  moment.locale(language);
  // return Months[date.getMonth()]
  return moment(date).format('MMMM');
}
